module.exports = __webpack_public_path__ + "media/images/turbochargers/BorgWarner-a02e94be0f3339dd1e4a2712d58a5518.jpg";